var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('entity',{attrs:{"only-columns":_vm.getOnlyColumns,"local-storage-prefix":_vm.localStoragePrefix},scopedSlots:_vm._u([{key:"appendActions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"color":"red"},on:{"click":function($event){$event.stopPropagation();return _vm.handleSupplierDisable(item)}}},[_vm._v(" mdi-cancel ")])]}}],null,false,177027697)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }